module.exports = __webpack_public_path__ + "static/img/home_logo4.5acea0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/home_logo4.png
// module id = yUXp
// module chunks = 3